import React, { useState } from "react";
import PageTitle from "../../../components/pageTitle/PageTitle";
import { Tabs, Tab } from "@mui/material";
import UnitSummary from "./unitType/UnitSummary";
import ClientStorageManagement from "../../pages/ClientStorageManagement";
import InvoiceLeadTime from "../settings/storageSettings/InvoiceLeadTime";
import { useDispatch } from "react-redux";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";
import ContractOdtTemplate from "../settings/storageSettings/ContractOdtTemplate";

const StorageSettingTabs = () => {
  const [activeTab, setActiveTab] = useState("unitType");
    const dispatch = useDispatch();
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setActiveTab(newValue);
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

  return (
    <>
      <PageTitle title="Storage Settings" />
      <Tabs
        // centered
        value={activeTab}
        onChange={handleChange}
        textColor="secondary"
        indicatorColor="secondary"
        aria-label="secondary tabs example"
        variant="standard"
        sx={{
          background: "#fff",
          fontSize: "14px",
          fontWeight: 600,
          marginBottom: "16px",
        }}
      >
        <Tab value="unitType" label="Storage Unit Type" />
        {/* <Tab value="site" label="Storage Site" /> */}
        <Tab value="invoiceTime" label="Invoice Lead Time" />
        <Tab value="contractODT" label="Contract ODT Template" />
      </Tabs>
      {activeTab === "unitType" && <UnitSummary />}
      {activeTab === "invoiceTime" && <InvoiceLeadTime />}
      {activeTab === "contractODT" && <ContractOdtTemplate />}
    </>
  );
};

export default StorageSettingTabs;
